import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "HolidayMessagingLazy" */ './HolidayMessaging'),
    {
        fallback: null,
    }
);
